module.exports = __webpack_public_path__ + "static/media/default-marker-blue.b71e6ad4.svg";